module.exports = __webpack_public_path__ + "img/logo-shu.8ae5dd08.png";